import React, { useState, useEffect } from "react";
import { motion } from 'framer-motion'
import { pageTransitions, transitionDuration } from "../../../../../Util/PageTransitions";
import "./Advertisements.css";
import AddAdvertisement from "./AddAdvertisement";
import AdvertisementItem from "./AdvertisementItem";
import WarningDialogue from "../../../../../Util/WarningDialogue";
import axiosApi from '../../../../../core/interceptor/interceptor';
import { config } from "../../../../../config";

export default function Advertisements(props) {
  const [advertisements, setAdvertisements] = useState([]);
  const [viewItemDetails, setViewItemDetails] = useState(false);
  const [selectedItem, setSelectedItem] = useState([]);
  const [isNewItem, setIsNewItem] = useState(false);
  const [popupContent, setPopupContent] = useState({});
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const setAddEditItem = (itemDetails = {
    image: '',
    name: '',
    hyper_link: '',
  }, newItem = isNewItem) => {
    setViewItemDetails(true);
    setSelectedItem(itemDetails);
    setIsNewItem(newItem);
  }

  const getAds = () => {
    axiosApi.get(`${config.apiUrl}/advertisement`)
    .then((res) => {
      setAdvertisements(res?.data?.data);
    })
  }

  useEffect(() => {
    getAds();
  }, []);

  const close = () => {
    setViewItemDetails(false);
  }
  const refresh = (flag) => {
    if (flag) {
      getAds();
    }
  }

  return <>
    {viewItemDetails && (
      <AddAdvertisement
        itemDetails={selectedItem}
        isNewItem={isNewItem}
        onClose={close}
        isAddOrEdit={refresh}
      />
    )}
    <motion.div
      className="adminMenuContainer addMenulist"
      initial={pageTransitions.initial}
      animate={pageTransitions.in}
      exit={pageTransitions.out}
      transition={{ duration: transitionDuration }}
    >
      <div className="content-wrapper menu-wrapper">
        <div className="heading-wrapper">
          <div className="left">
            <h1 className="heading">
              Sponsors
            </h1>
          </div>
        </div>
        <div className='admin-menu-section-wrapper'>
          {/* <AnimatePresence exitBeforeEnter>
            <motion.div className='modifyAdminMenuSectionTitleContainer' key='sdiofhjw02ejr0' initial={backdropTransition.initial} animate={backdropTransition.in} exit={backdropTransition.out} transition={{ duration: transitionDuration }}>
              <div className="admin-main-category-head">
                <h1 className='adminMenuSectionTitle'></h1>
              </div>
            </motion.div>
          </AnimatePresence> */}
          <div>
            <div className="adminMenuSectionContainer">
          <div className={`adminMenuItemsContainer adminMenuItemsContainer-website  home-slider-grid`}>
            { advertisements && advertisements.length ? advertisements?.map((value, index) => (
              <AdvertisementItem itemDetails={value} isItemDelete={refresh} key={index} setItemDisplay={() => setAddEditItem({id: value?.id, image: value.image, name: value?.name, hyper_link: value?.hyper_link}, false)} viewItemDetails={props.viewItemDetails} />
            )) : ''}
            {<div className='addnew-item-block' onMouseDown={() => setAddEditItem(undefined, true)}>
              <div className="box-content-item">
                <div className="addsign"><span>+</span></div>
                <h2 className='adminMenuItemTitle'>Add New Item</h2>
                <p className='adminMenuItemDescription'>Add a new item to Sponsor</p>
              </div>
            </div>}
          </div>
          </div>
          </div>
        </div >
      </div>

    </motion.div>
    <WarningDialogue
      isOpen={openWarningPopup}
      header={popupContent.header}
      description={popupContent.description}
      icon={popupContent.icon}
      action={popupContent.action}
      onClose={() => setOpenWarningPopup(false)}
    />
  </>
}